/* eslint-disable import/no-extraneous-dependencies */
import { Button, Typography, colors } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Expand as ExpandIcon, Minimize as MinimizeIcon } from '@tassat/icon';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';
import { startCase, toLower } from 'lodash';
import * as React from 'react';

import RecordsExpandMinimizeProps from './types';

const useRecordsExpandMinimizeBtnStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        textTransform: 'none',
        color: theme?.app?.applicationColors.enumColors.white || colors.common.white,
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.white || colors.common.white}`,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
            border: `1px solid ${theme?.app?.applicationColors.enumColors.white || colors.common.white}`
        },
        borderRadius: '2px'
    },
    text: { lineHeight: `${theme.spacing?.(1.375)}` },
    icon: {
        height: theme.spacing?.(1.25),
        width: theme.spacing?.(1.25)
    }
}));

const RecordsExpandMinimize: React.FC<RecordsExpandMinimizeProps> = ({ onClick, isExpanded, classes = {}}) => {
    const classesNames = useRecordsExpandMinimizeBtnStyles();

    return (
        <Button
            classes={{ startIcon: classes.startIcon }}
            className={`${classesNames.root} ${classes.root}`}
            onClick={onClick}
            startIcon={isExpanded ?
                <MinimizeIcon className={`${classesNames.icon} ${classes.startIcon}`} />
                : <ExpandIcon className={`${classesNames.icon} ${classes.startIcon}`} />}
        >
            <Typography
                className={`${classesNames.text} ${classes.text}`}
                variant='body2'
            >
                {isExpanded ? startCase(toLower('Minimize All')) : startCase(toLower('Expand All'))}
            </Typography>
        </Button>
    );
};

export default RecordsExpandMinimize;